import Offline from './Offline'

class ContratAssemblage {

    constructor() {

        this.data = {}

    }

    saveContrat(data) {

        return new Promise((resolve, reject) => {

            if (navigator.onLine) {
                this
                    .saveContratOffline(data)
                    .then(res => resolve(res))
                    .catch(err => reject(err))
            } else {
                this
                    .saveContratOffline(data)
                    .then(res => resolve(res))
                    .catch(err => reject(err))
            }

        })

    }

    saveContratOnline(data) {

        return new Promise((resolve, reject) => {

            localforage.getItem('api-token')
                .then(key => {

                    let params = {
                        baseURL: urlAPI,
                        timeout: 5000,
                        headers: {
                            'Authorization': 'Bearer ' + key,
                        }
                    };

                    let api = axios.create(params);

                    api
                        .post('/contrat', {
                            detenteur: data.id_detenteur,
                            typeEquipement: data.type_equipement,
                            fluide: data.id_fluide,
                            periodeValidite: data.validite,
                            observations: data.details,
                            acquereurNom: data.nom_acquereur,
                            acquereurSignature: data.signature
                        })
                        .then(result => resolve(result))
                        .catch(err => reject(err))

                })
                .catch(err => reject(err))

        })

    }

    saveContratOffline(contrat) {

        return new Promise((resolve, reject) => {

            this
                .getList()
                .then(list => {

                    let newKey = 'N-' + +new Date();
                    contrat.id = newKey;
                    list.push(contrat);

                    localforage
                        .setItem('listAssemblages', JSON.stringify(list))
                        .then(res => {

                            Offline.saveAction({
                                action: 'add',
                                type: 'ContratAssemblage',
                                id: newKey
                            });

                            resolve(res)

                        })
                        .catch(err => reject(err))

                })
                .catch(err => reject(err))

        })

    }

    deleteContrat(id) {

        return new Promise((resolve, reject) => {

            this
                .getList()
                .then(list => {

                    if (!_.includes(id, 'N-')) {
                        id = parseInt(id)
                    }

                    let indexToDelete = _.findIndex(list, ['id', id]);
                    list.splice(indexToDelete, 1);

                    localforage
                        .setItem('listAssemblages', JSON.stringify(list))
                        .then(resolve(true))
                        .catch(reject('Erreur delete assemblage'))

                })
                .catch(err => reject(err))
        })

    }

    getContrat(id) {
        return new Promise((resolve, reject) => {
            this
                .getList()
                .then(data => {
                    if (!_.includes(id, 'N-')) {
                        id = parseInt(id)
                    }
                    let contrat = _.find(data, ['id', id]);
                    if (contrat) {
                        resolve(contrat)
                    } else {
                        reject('Inexistant')
                    }
                })
                .catch(err => reject(err))
        })
    }

    getList() {

        return new Promise((resolve, reject) => {

            localforage
                .getItem('listAssemblages')
                .then(data => resolve(JSON.parse(data)))
                .catch(err => reject(err))

        })

    }

}

export default ContratAssemblage



// WEBPACK FOOTER //
// ./src/js/models/ContratAssemblage.js